import { useEffect, useRef, useState } from "react";
import { ALL_VISIBLE } from "../../conts/constants.js";
import { buildLegend } from "../../utils/legend.js";

// Legend content, its open/closed state, and which result layers are visible.
const useLegend = ({ impacts, viewed, realPolygon, simPolygon }) => {
  const [legendOpen, setLegendOpen] = useState(true);
  const [impactVisible, setImpactVisible] = useState(ALL_VISIBLE);

  // lets the map sync effects read the latest toggles without re-running
  const impactVisibleRef = useRef(impactVisible);
  impactVisibleRef.current = impactVisible;

  const toggleImpact = (key) =>
    setImpactVisible((v) => ({ ...v, [key]: !v[key] }));
  const toggleLegend = () => setLegendOpen((v) => !v);

  // every time a historic analysis is opened, the legend starts again with everything visible
  useEffect(() => {
    setImpactVisible(ALL_VISIBLE);
  }, [viewed?.data]);

  // auto open the legend when there are results to show
  useEffect(() => {
    if (impacts?.data?.results || viewed?.data) setLegendOpen(true);
  }, [impacts?.data, viewed?.data]);

  const legend = buildLegend({ impacts, viewed, realPolygon, simPolygon });

  return {
    legend,
    legendOpen,
    toggleLegend,
    impactVisible,
    impactVisibleRef,
    toggleImpact,
  };
};

export default useLegend;
